(() => {
  const animatedSelector = '.shopify-section';
  const visibleClass = 'yao-scroll-visible';

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.classList.add('yao-scroll-ready');
    document.querySelectorAll(animatedSelector).forEach((section) => section.classList.add(visibleClass));
    return;
  }

  const revealSection = (section) => {
    section.classList.add(visibleClass);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        revealSection(entry.target);
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.16,
    }
  );

  const init = () => {
    document.documentElement.classList.add('yao-scroll-ready');

    document.querySelectorAll(animatedSelector).forEach((section) => {
      const rect = section.getBoundingClientRect();

      if (rect.top < window.innerHeight * 0.7) {
        revealSection(section);
        return;
      }

      observer.observe(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
